import {getEventTitle, getFormattedFullLocation} from '@wix/wix-events-commons-statics'
import {detailsPageDataHooks as DH} from '@wix/wix-events-data-hooks'
import {Text} from '@wix/wix-ui-tpa/cssVars'
import {useEnvironment} from '@wix/yoshi-flow-editor'
import classNames from 'classnames'
import React from 'react'
import {useEventDateInformation} from '../../../../../../../commons/hooks/dates'
import {useAppSelector} from '../../../../hooks/runtime'
import {getEvent} from '../../../../selectors/event'
import {classes} from './event-info.st.css'

export const EventInfo = () => {
  const {isMobile} = useEnvironment()

  const event = useAppSelector(getEvent)

  const {fullDate} = useEventDateInformation(event.id)

  return (
    <div className={classNames(classes.container, {[classes.desktopContainer]: !isMobile})}>
      <Text tagName="h1" className={classNames(isMobile ? classes.mobileName : classes.name)} data-hook={DH.EVENT_INFO}>
        {getEventTitle(event)}
      </Text>
      <Text tagName="p" className={classes.dateLocation}>
        {fullDate}
      </Text>
      <Text tagName="p" className={classes.dateLocation}>
        {getFormattedFullLocation(event)}
      </Text>
    </div>
  )
}
